import { useMemo } from 'react';
import { gql, useQuery } from 'urql';
import { TicketsFilterInput, Ticket } from '@pages/event/api/useFetchTicketSegment';

export const GET_SEGMENTS_BY_DEPARTMENTS_QUERY = gql`
  query GetSegmentsByDepartments($eventId: Int!, $input: TicketsFilter!) {
    getSegmentsByDepartments(eventId: $eventId, input: $input) {
      id
      title
      departments {
        id
        name
        active
        tickets {
          id
          checked
          active
          ticketSegmentId
          smsTicketSent
          emailTicketSent
          checkInTime
          invitationStatus
          smsInviteSent
          emailInviteSent
          checkedBy
          scanType
          organizerName
          categories {
            title
            color
          }
          participant {
            id
            position
            phone
            firstName
            lastName
            avatar
            confirmed
            sortNumber
            active
            surname
            source
            isIndividual
            joinedAt
            leftAt
          }
        }
        childDepartment {
          id
          name
          active
          tickets {
            id
            checked
            smsInviteSent
            emailInviteSent
            active
            ticketSegmentId
            smsTicketSent
            emailTicketSent
            invitationStatus
            checkInTime
            checkedBy
            scanType
            organizerName
            categories {
              title
              color
            }
            participant {
              id
              position
              phone
              firstName
              lastName
              avatar
              confirmed
              sortNumber
              active
              surname
              source
              isIndividual
              joinedAt
              leftAt
            }
          }
          childDepartment {
            id
            name
            active
            tickets {
              id
              checked
              active
              smsInviteSent
              emailInviteSent
              ticketSegmentId
              smsTicketSent
              emailTicketSent
              checkInTime
              checkedBy
              invitationStatus
              scanType
              organizerName
              categories {
                title
                color
              }
              participant {
                id
                position
                phone
                firstName
                lastName
                avatar
                confirmed
                sortNumber
                active
                surname
                source
                isIndividual
                joinedAt
                leftAt
              }
            }
            childDepartment {
              id
              name
              active
              tickets {
                id
                checked
                active
                ticketSegmentId
                smsTicketSent
                emailTicketSent
                smsInviteSent
                emailInviteSent
                checkInTime
                checkedBy
                invitationStatus
                scanType
                organizerName
                categories {
                  title
                  color
                }
                participant {
                  id
                  position
                  phone
                  firstName
                  lastName
                  avatar
                  confirmed
                  sortNumber
                  active
                  surname
                  source
                  isIndividual
                  joinedAt
                  leftAt
                }
              }
              childDepartment {
                id
                name
                active
                tickets {
                  id
                  checked
                  active
                  ticketSegmentId
                  smsTicketSent
                  emailTicketSent
                  smsInviteSent
                  emailInviteSent
                  checkInTime
                  checkedBy
                  scanType
                  organizerName
                  invitationStatus
                  categories {
                    title
                    color
                  }
                  participant {
                    id
                    position
                    phone
                    firstName
                    lastName
                    avatar
                    confirmed
                    sortNumber
                    active
                    surname
                    source
                    isIndividual
                    joinedAt
                    leftAt
                  }
                }
                childDepartment {
                  id
                  name
                  active
                }
              }
            }
          }
        }
      }
    }
  }
`;

export interface GetSegmentsByDepartmentsResponse {
  getSegmentsByDepartments: DepartmentTicketSegment[];
}

export interface DepartmentTicketSegment {
  id: number;
  title: string;
  departments: EmployeeDepartment[];
}

export interface EmployeeDepartment {
  id: number;
  name: string;
  active: boolean;
  tickets: Ticket[];
  childDepartment?: EmployeeDepartment[];
}
export interface CategoryData {
  title: string;
  color: string | null;
}

export interface Employee {
  id: number;
  uuid: string;
  email: string;
  login: string;
  position: string | null;
  phone: string | null;
  firstName: string;
  lastName: string;
  avatar: string | null;
  confirmed: boolean;
  sortNumber: number;
  active: boolean;
  surname: string | null;
  source: string | null;
  isIndividual: boolean;
  departmentUuid: string | null;
  createdAt: string;
  updatedAt: string;
  joinedAt: string | null;
  leftAt: string | null;
}

export const useGetSegmentsByDepartments = (eventId: number | undefined, input?: TicketsFilterInput) => {
  const variables = useMemo(
    () => ({
      eventId,
      input: input ?? {
        inviteFilter: null,
        ticketFilter: null,
        orderBy: null,
      },
    }),
    [eventId, input]
  );

  const [result, reexecuteQuery] = useQuery<GetSegmentsByDepartmentsResponse>({
    query: GET_SEGMENTS_BY_DEPARTMENTS_QUERY,
    variables,
    pause: !eventId,
    requestPolicy: 'network-only',
  });

  return {
    data: result.data,
    fetching: result.fetching,
    error: result.error,
    refetch: reexecuteQuery,
  };
};
